<template>
    <div>
        <Title title="优惠券" :path="formPath"/>
        <div class="page-loading" v-if="isInit === true">
            <van-skeleton title :row="8" />
        </div>
        <template v-else>
            <div class="coupon">
                <coupon_mini :data="list"/>
                <div class="tips">
                    <div class="tcc">优惠券说明：</div>
                    <div class="tcn">
                        <p class="t">一、什么是优惠券</p>
                        <p class="ta">优惠券是本站通过线上活动、推广活动等形式发放给用户，用于减免支付金额的优惠措施。</p>
                        <p class="ta">满减券是用来直接减免部分订单金额的优惠券。满减券的使用受订单总金额的限制。订单必须符合满减券的使用条件才可使用。</p>
                        <p class="ta">比如：消费满500FXB减50FXB代金券，需要在订单金额中，消费金额大于等于500FXB时才可减免50FXB。</p>
                        <p></p>
                        <p class="ta t">温馨提示：</p>
                        <p class="ta">加入购物车合并订单支付可使用大额优惠券，“优惠券”可以和“积分抵扣”同时使用。</p>
                        <p></p>
                        <p class="t">二、优惠券使用细则</p>
                        <div><span>1、</span><p>优惠券适用于在本站注册的个人会员;</p></div>
                        <div><span>2、</span><p>每张优惠券仅能使用一次，不能兑换现金，不找零，不退换；</p></div>
                        <div><span>3、</span><p>优惠券应在券面标示或系统显示的有效期内使用，过期作废;</p></div>
                        <div><span>4、</span><p>使用优惠券订阅专家预测的订单，若发生不中返还，订阅单个专家预测的优惠，按实际支付金额返还；订阅多个专家预测的优惠，按专家预测售价所占订单金额比例等额拆分实际支付金额进行返还。</p></div>
                        <div><span>5、</span><p>本规则由本站依据国家相关法律法规及规章制度予以解释。</p></div>

                    </div>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
    import coupon_mini from './public/coupon_mini'
    import Title from './public/title'
    export default {
        name: "coupon",
        components: {
            coupon_mini,
            Title
        },
        data() {
            return {
                isInit: true,
                list: [],
                formPath: ''
            }
        },
        watch: {
            // '$route': {
            //     handler: function () {
            //         this.getdata()
            //     }
            // }
        },
        activated() {
            let that = this
            that.getdata()
        },
        methods: {
            getdata(){
                let that = this
                that.$get(that.$api.coupon_list)
                    .then(function (res) {
                        if(res.code === 1) {
                            that.list = res.data.list
                            that.isInit = false
                        }
                    })
            },
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path
            })
        }
    }
</script>

<style scoped>
</style>
